<template>
  <div style="position:relative; top:30px;">
    <span v-if="!textLoaded">
      Please select a country, language and file in the toolbar above to start.<br>
      When you have selected an input field to edit
      click on the editor button in the toolbar to have more edit features<br>
      When only altering text or adding variables
      you can do that directly in the input field.
    </span><br>
  </div>
</template>

<script>
export default {
  props: ['textLoaded'],
};
</script>
